export default __webpack_public_path__ + "static/media/text-seal.3a572498.svg";